import { createSlice } from '@reduxjs/toolkit';
import { getVacancyControlListThunk } from './VacancyControl.thunk';
import { VacancyControlState } from './VacancyControl.type';
import { RootState } from '../../store';

const SLICE_NAME = 'vacancyControl';

const initialState: VacancyControlState = {
  items: [],
  isLoading: false,
  pagination: undefined,
};

export const vacancyControlSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setVacancyControlList: (state, action) => ({
      ...state,
      items: action.payload,
    }),
  },
  extraReducers: builder => {
    builder.addCase(getVacancyControlListThunk.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(
      getVacancyControlListThunk.fulfilled,
      (state, { payload }) => {
        const { data, pagination } = payload;
        state.isLoading = false;
        state.items = data;
        state.pagination = {
          currentPage: pagination.current_page,
          lastPage: pagination.last_page,
          perPage: pagination.per_page,
          from: pagination.from,
          to: pagination.to,
          total: pagination.total,
        };
      },
    );
    builder.addCase(getVacancyControlListThunk.rejected, state => {
      state.isLoading = false;
    });
  },
});

export const {
  setVacancyControlList
} = vacancyControlSlice.actions;

export const getVacancyControlList = (state: RootState) =>
  state.vacancyControl.items;

export const getVacancyControlListPagination = (state: RootState) =>
  state.vacancyControl.pagination;


export default vacancyControlSlice.reducer;
